import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/actions/userActions";
import styles from "../styles/Header.module.css";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isSidebarCollapsed,
  toggleSidebar,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const username = useSelector((state: any) => state.user.username); // Get username from Redux store

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/"); // Redirect to login page
  };

  return (
    <header
      className={`${styles.header} ${
        isSidebarCollapsed ? styles.collapsed : ""
      }`}
    >
      <IconButton onClick={toggleSidebar} className={styles.menuButton}>
        <MenuIcon />
      </IconButton>

      {/* Right Section */}
      <div className={styles.rightSection}>
        <NotificationsIcon className={styles.icon} />

        {/* Profile Dropdown */}
        <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
          <div className={styles.profileContainer}>
            <Avatar
              className={styles.avatar}
              src="/profile.jpg" // Change this to your actual profile image source
              alt="Avatar"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            />
            {dropdownOpen && (
              <div className={styles.dropdownMenu}>
                <p className={styles.username}>{username || "Admin"}</p>
                <button className={styles.logoutButton} onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        </ClickAwayListener>
      </div>
    </header>
  );
};

export default Header;

// import React from "react";
// import styles from "../styles/Header.module.css";
// import MenuIcon from "@mui/icons-material/Menu";
// import SearchIcon from "@mui/icons-material/Search";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import Avatar from "@mui/material/Avatar";
// import IconButton from "@mui/material/IconButton";

// interface HeaderProps {
//   isSidebarCollapsed: boolean;
//   toggleSidebar: () => void;
// }

// const Header: React.FC<HeaderProps> = ({
//   isSidebarCollapsed,
//   toggleSidebar,
// }) => {
//   return (
//     <header
//       className={`${styles.header} ${
//         isSidebarCollapsed ? styles.collapsed : ""
//       }`}
//     >
//       <IconButton onClick={toggleSidebar} className={styles.menuButton}>
//         <MenuIcon />
//       </IconButton>
//     </header>
//   );
// };

// export default Header;

// -----------------------------------------------------------

// import React from 'react';
// import styles from '../styles/Header.module.css';
// import { Link } from 'react-router-dom';

// const Header: React.FC = () => {
//   return (
//     <>

//       {/* Navigation Bar */}
//       <header className={styles.header}>
//         <div className={styles.logo}><img src="/VV_Logo.png"   style={{
//                     width: '50px', // Adjust size as needed
//                     height: '50px',
//                     borderRadius: '50%', // To make it circular

//                   }} /> VV Trips</div>
//         <nav className={styles.navbar}>
//           <ul>
//             <li><a href="/">Trips</a></li>
//             <li><a href="/blogs">Blogs</a></li>

//           </ul>
//         </nav>
//         <a href="/book-now" className={styles.bookNowBtn}>Admin</a>
//       </header>

//       {/* Banner Section */}
//       <div className={styles.banner}>
//         <div className={styles.bannerOverlay}>
//           <h1 className={styles.bannerTitle}>JOURNEY TO EXPLORE WORLD</h1>
//           {/* <p className={styles.bannerSubtitle}>
//             Ac mi duis mollis. Sapiente? Suscipit class corporis nostra rem quos voluptatibus habitant?
//           </p>
//           <div className={styles.bannerButtons}>
//             <a href="#" className={styles.primaryBtn}>EXPLORE</a>
//             <a href="#" className={styles.secondaryBtn}>BOOK NOW</a>
//           </div> */}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;
